<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:14:49
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-05-27 19:18:03
 * @Description: 统计数据卡片模块
 -->
<template>
  <div class="observe-data">
    <div class="observe-data__times">
      <!-- <p>统计区间：<span>{{startTime}}</span> 至 <span>{{endeTime}}</span></p> -->
      <p>统计截至 <span>{{updateTime}}</span></p>
    </div>
    <!-- <a-popover class="observe-data__descript" placement="bottomRight" overlayClassName="observe-data__descript-detail">
      <template slot="content">
        <p>数据说明数据说明数据说明数据说明数据说明数据说明数据说明数据说明数据说明数据说明数据说明</p>
      </template>
      <a-icon type="question-circle" />
      <span>数据说明</span>
    </a-popover> -->
    <div class="observe-data__swiper swiper-container" ref="swiper-container">
      <div class="swiper-wrapper">
        <card-day @staEndTime="staEndTime" class="observe-data__swiper-item swiper-slide"></card-day>
        <card-week class="observe-data__swiper-item swiper-slide"></card-week>
        <card-month class="observe-data__swiper-item swiper-slide"></card-month>
        <card-season class="observe-data__swiper-item swiper-slide"></card-season>
        <card-year class="observe-data__swiper-item swiper-slide"></card-year>
      </div>
    </div>
    <div ref="swiper-pagination" class="observe-data__swiper-pagination"></div>
  </div>
</template>

<script>
import moment from 'moment'
import Swiper from 'swiper'
// import 'swiper/css/swiper.css'

import CardDay from './day'
import CardWeek from './week'
import CardMonth from './month'
import CardSeason from './season'
import CardYear from './year'

export default {
  components: {
    CardDay,
    CardWeek,
    CardMonth,
    CardSeason,
    CardYear,
  },
  data() {
    return {
      startTime: null,
      endeTime: null,
      updateTime: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getStatisticsTime()
      this.initSwiper()
    })
  },
  methods: {
    initSwiper() {
      // eslint-disable-next-line no-new
      this.swiper = new Swiper(this.$refs['swiper-container'], {
        loop: false, // 循环
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        touchStartPreventDefault: false, // 添加该属性
        pagination: {
          el: this.$refs['swiper-pagination'],
          type: 'custom',
          clickable: true,
          renderCustom(swiper, current, total) {
            let paginationStyle = ''
            let html = ''
            for (let i = 1; i <= total; i += 1) {
              if (i === current) {
                paginationStyle = 'width:22px;height:6px;background:#005EFF;opacity:1;margin-right:8px;border-radius:3px;'
              } else {
                paginationStyle = 'width:8px;height:6px;background:#ccc;opacity:1;margin-right:8px;border-radius:3px;'
              }
              html += `<span class="swiper-pagination-bullet inline-block cursor-noLink" style=${paginationStyle}></span>`
            }
            return html
          },
        },
      })
    },
    /**
     * 获取覆盖率数据
     */
    getStatisticsTime() {
      this.updateTime = moment().format('YYYY-MM-DD HH:00')
    },
    // staEndTime(time) {
    staEndTime() {
      // this.updateTime = moment(time).format('YYYY-MM-DD HH:00')
    },
  },
}
</script>

<style lang="scss">
.observe-data {
  position: relative;
}
.observe-data__times {
  padding: 0 40px;
  font-size: 24px;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color: #757575;
  p {
    margin: 0.9em 0;
  }
  span {
    color: #222;
    font-weight: 500;
  }
}
.observe-data__descript {
  position: absolute;
  top: 14px;
  right: 40px;
  font-size: 20px;
  font-family: PingFangSC-Light,PingFang SC;
  font-weight: 300;
  color: #757575;
  >span {
    margin-left: 10px;
  }
}
.observe-data__descript-detail {
  width: 200px;
  color: red;
}

.observe-data__swiper {
  margin:0;
  .observe-data__swiper-item {
    cursor: pointer;
  }
}
.observe-data__swiper-pagination {
  background-color: #fff;
  text-align: center;
  padding-right: 10px;
  z-index: 4;
  // position: absolute;
  // bottom: 10px;
}
.observe-data__card-container-1 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  div:nth-child(1) {
    border-top-left-radius: 10px;
  }
  div:nth-child(3) {
    border-top-right-radius: 10px;
  }
}
.observe-data__card-container-2 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  div:nth-child(1) {
    border-bottom-left-radius: 10px;
  }
  div:nth-child(3) {
    border-bottom-right-radius: 10px;
  }
}
</style>
